const testIds = {
  message: 'message',
};

export default testIds;
